import { addLog } from '@/api/lib/addLog.js'
/**
 * 通用请求重试方法
 * 业务底层使用 jquery.soap，网络/业务错误会通过 $notify.error 统一抛出 Error
 * （message 为 '$notify.error ternimal current thread'），所以这里只要捕获异常重试即可。
 *
 * @param {Function} requestFn - 请求函数，返回 Promise
 * @param {number} maxRetries - 最大重试次数，默认 2 次
 * @returns {Promise} - 返回请求结果
 *
 * @example
 */
const maxRetries = 2
export async function retryRequest(requestFn, outboundNo) {
  let lastError;
  for (let i = 0; i <= maxRetries; i++) {
    try {
      let res = await requestFn();
      return res
    } catch (error) {
      addLog('processingCheckResult-checkMR', 'customer_200_fail',{outboundNo,i, info: JSON.stringify(getFullData(error))});
      if(error.status !== 0){
        throw error;
      }
      lastError = error;
    }
  }
  throw lastError;
}

// 返回当前路由的 path（含 query），如 "/suPackNew?a=1"。
// 路由已是 history 模式，直接取 pathname+search 即可；
// 旧 hash 链接在 index.html 的 normalize 脚本里已于应用启动前改写为 history，
// 故此处运行时 location.hash 恒为空，无需再兼容 hash。
export const getRoutePath = () => {
  return window.location.pathname + window.location.search;
};

export const getFullData = (target) => {
  // null / undefined 归一化为空对象，保证外层 JSON.stringify 结果稳定（不会得到 undefined）
  if (target === null || target === undefined) {
    return {};
  }
  // 原始类型直接包装，避免字符串被拆成字符数组等问题
  if (typeof target !== 'object' && typeof target !== 'function') {
    return { value: target };
  }
  const keys = Object.getOwnPropertyNames(target);
  return keys.reduce((acc, key) => {
    acc[key] = target[key];
    return acc;
  }, {});
};